<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    show?: boolean;
    count?: number;
    color?: string;
    size?: "sm" | "default";
  }>(),
  {
    show: false,
    color: "var(--primary-blue-color)",
    size: "default",
  },
);

const hasCount = computed(() => props.count !== undefined);
const displayCount = computed(() => {
  if (!hasCount.value) return "";
  return props.count! > 99 ? "99+" : String(props.count);
});
</script>

<template>
  <div class="relative inline-flex">
    <slot />
    <span
      v-if="show"
      class="absolute flex items-center justify-center rounded-full text-white pointer-events-none"
      :class="[
        size === 'sm'
          ? 'w-[10px] h-[10px] text-[6px] -right-[1px] -top-[3px]'
          : 'w-[18px] h-[18px] text-[10px] -right-[6px] -top-[10px]',
      ]"
      :style="{ backgroundColor: color }"
    >
      {{ displayCount }}
    </span>
  </div>
</template>
